<template>
  <div class="d-flex" id="page-dashboard">
    <MainBarMenu />
    <div class="layout-content container-fluid">
      <HeadingUser title="Dashboard" />
      <div class="row mt-3 mt-md-5">
        <div class="col-md-12 mb-3">
          <div class="cont-title d-flex align-items-center mb-4">
            <span class="icon icon-wait-clock mr-3"></span>
            <h3 class="mb-0">Desarrollo de procesos en el tiempo</h3>
          </div>
          <div class="text-right mb-3">
            <router-link to="/allProcess" class="text-blue">Procesos por colaborador</router-link>
          </div>
          <!-- .cont-title -->
          <div class="row">
            <div class="col-md-4">
              <!-- .cont-title -->
              <div class="position-relative cont-doughnut-chart">
                <div>
                  <b-card
                    header="Filtros"
                    header-tag="header"
                  >




                    <p class="mt-3">Sanción:</p>
                    <b-form-select 
                      v-model="penaltySel"
                      @change="updataDataProcesses()">
                        <option value="">--</option>
                        <option v-for="item in penalties" :key="item.id" :value="item.id">
                          {{ item.name }}
                        </option>
                    </b-form-select>
                    
                    <p class="mt-3">Categoría:</p>
                    <b-form-select 
                      v-model="prioritySel"
                      @change="updataDataProcesses()">
                        <option value="">--</option>
                        <option value="11">Baja</option>
                        <option value="12">Media</option>
                        <option value="13">Alta</option>
                    </b-form-select>

                    <p class="mt-3">Apelación:</p>
                    <b-form-select 
                      v-model="appealSel"
                      @change="updataDataProcesses()">
                        <option value="">--</option>
                        <option value="1">Con apelación</option>
                        <option value="0">Sin apelación</option>
                    </b-form-select>

                    <p class="mt-3">Revisión:</p>
                    <b-form-select 
                      v-model="reviewSel"
                      @change="updataDataProcesses()">
                        <option value="">--</option>
                        <option value="1">Con revisión</option>
                        <option value="0">Sin revisión</option>
                    </b-form-select>

                    <p class="mt-3">Estado:</p>
                    <b-form-select 
                      v-model="stateSel"
                      @change="updataDataProcesses()">
                        <option value="">--</option>
                        <option v-for="item in states" :key="item.id" :value="item.id">
                          {{ item.name }}
                        </option>
                    </b-form-select>

                    <p class="mt-3">Año:</p>
                    <b-form-select 
                      v-model="yearSel"
                      @change="updataDataProcesses()">
                        <option :value="this.year">Año {{this.year}}</option>
                        <option :value="this.year-1">Año {{this.year-1}}</option>
                        <option :value="this.year-2">Año {{this.year-2}}</option>
                    </b-form-select>

                    <p class="mt-3">Sociedad:</p>
                    <b-form-select 
                      v-model="societySel"
                      @change="updataDataProcesses()">
                        <option value="">--</option>
                        <option v-for="item in societies" :key="item.id" :value="item.id">
                          {{ item.name }}
                        </option>
                    </b-form-select>

                    <p class="mt-3">Site:</p>
                    <b-form-select 
                      v-model="siteSel"
                      @change="updataDataProcesses()">
                        <option value="">--</option>
                        <option v-for="item in sites" :key="item.id" :value="item.id">
                          {{ item.name }}
                        </option>
                    </b-form-select>
                    
                  </b-card>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="shadow-1 cont-chart p-1">
                <time-tickets-chart v-if="refresh"
                  :chart-data="processLineChartdatacollection"
                  :options="processLineChartOptions"
                />
              </div>
            </div>
          </div>
          <!-- .cont-chart -->
        </div>
      </div>
      <!-- .row -->
      <div class="mb-menu"></div>
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-dashboard -->
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import serverConfig from "./../../services/config";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";

import TimeTicketsChart from "@/components/charts/TimeTicketsChart.js";
// import AvailabilityPermissionsChart from "@/components/charts/AvailabilityPermissionsChart.js";

export default {
  name: "Dashboard",
  components: {
    MainBarMenu,
    HeadingUser,
    TimeTicketsChart,
    // AvailabilityPermissionsChart,
  },
  data() {
    return {

      available_tickets:[],
      availabilityTicketsChartdatacollection: null,
      halfLicenses: null,
      available_licenses: null,
      availabilityTicketsChartOptions: null,

      serverPath: serverConfig.permisosURL,

      societySel: "",
      siteSel: "",
      penaltySel: "",
      prioritySel: "",
      appealSel: "",
      reviewSel: "",
      stateSel: "",
      
      yearSel: "",
      year: "",

      processLineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          align: "center",
          labels: {
            boxWidth: 15,
            fontSize: 15,
            padding: 10,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    };
  },
  beforeMount() {
    this.actGetSites();
    this.actGetSocieties();
    this.actGetPenalties();
    this.actGetStates();

    let date = new Date();
    this.year = date.getFullYear();
    this.yearSel = this.year-1;

    this.updataDataProcesses();
  },
  computed: {    
    ...mapState("modCore", ["user"]),
    ...mapState("modProcessDashboard", [
      "sites",
      "societies",
      "processes",
      "processLineChartdatacollection",
      "refresh",
      "states",
    ]),
    ...mapState("modProcessEmployee", [
      "penalties",
    ]),
  },
  methods: {
    ...mapActions("modProcessDashboard", [
      "actGetSites",
      "actGetSocieties",
      "actGetProcesses",
      "actGetStates",
    ]),
    ...mapActions("modProcessEmployee", [
                                        "actGetPenalties",
                                        ]),
    ...mapMutations("modProcessDashboard", [
      "setRefresh"
    ]),
    updataDataProcesses (){
      this.setRefresh(false);
      this.actGetProcesses({
        year: this.yearSel,
        society: this.societySel,
        site: this.siteSel,
        penalty: this.penaltySel,
        priority: this.prioritySel,
        appeal: this.appealSel,
        review: this.reviewSel,
        state: this.stateSel,
        });
    },
  },
};
</script>
<style scoped>
a {
  color: #454545;
  text-decoration: underline;
}
a:hover {
  color: #454545;
}
</style>
<style lang="scss">

#page-dashboard {
  .cont-title {
    h3 {
      color: #1c3a4e;
      font-size: 12px;
      line-height: 18px;
      line-height: 22px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .icon {
      color: #1c3a4e;
      font-size: 18px;

      @media (min-width: 768px) {
        font-size: 22px;
      }
    }
  }

  .cont-chart {
    .chart-select {
      border: 0 none;
      color: #303030;
      font-weight: 500;
      outline: none;

      &:focus {
        outline: none;
      }
    }
  }

  .cont-doughnut-chart {
    .cont-txt {
      color: #303030;
      width: 126px;
      height: 120px;
      top: calc(50% - 60px);
      left: calc(50% - 63px);

      .title {
        font-size: 14px;
        margin-bottom: 0;
      }
      .number {
        font-size: 40px;
        line-height: 40px;
        font-weight: bold;
        margin-bottom: 0;
        padding: 10px 0;
      }

      .cont-desc {
        font-size: 12px;
        p {
          margin-bottom: 0;
        }
      }
    }
  }

  .cont-permisions {
    color: #303030;
    .number {
      font-size: 28px;
      font-weight: bold;

      @media (min-width: 768px) {
        font-size: 48px;
      }
    }
    .txt {
      font-size: 14px;
      line-height: 16px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
}
</style>